export default __webpack_public_path__ + "static/media/copy-button-grayed-out.5289bfd7.svg";